import { useCallback, useEffect, useState } from 'react';
import { Form } from 'antd';
import { getClickupSpaceForSection, postClickupListBySpaceForSection } from '../../../../config';
import { getFormInfo } from '../util/FormHelper';

const useForm = ({ data = {} }) => {
    const [form] = Form.useForm();
    const [color, setColor] = useState('#000000')
    const [loading, setLoading] = useState(false)
    const [infoClickup, setInfoClickup] = useState({
        spaces: [],
        lists: [],
        listsRemove: []
    })

    const getSpacesClickupForSection = useCallback((action = null) => {
        setLoading(true);
        getClickupSpaceForSection()
            .then((res) => {
                setInfoClickup(prev => ({
                    ...prev,
                    spaces: res.payload
                }))
                if (action) action()
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }, [])

    const getListsByClickupSpace = useCallback((action = null) => {
        const { spaces } = form.getFieldsValue();
        if (!spaces.length) return;
        const listSpaceIds = spaces.map((space) => infoClickup.spaces.find((item) => item.id === space))
        setLoading(true);
        postClickupListBySpaceForSection({ listSpaceIds })
            .then((res) => {
                setInfoClickup(prev => ({
                    ...prev,
                    lists: res.payload
                }))
                form.setFieldsValue({
                    lists: []
                })
                if (action) action()
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }, [form, infoClickup.spaces])

    const changeColor = useCallback(
        (e) => {
            setColor(e.target.value);
        },
        [],
    )

    const initForm = useCallback(() => {
        const { infoForm, color, lists } = getFormInfo(data)
        form.setFieldsValue(infoForm);
        setColor(color)
        console.log(lists);
        const listsRemove = lists.map((list) => ({
            id: list.clickupId,
            name: `${list.listRoot?.space?.name} / ${list.listRoot?.folder?.name || ''} / ${list.name}`
        }))
        setInfoClickup(prev => ({
            ...prev,
            listsRemove
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form]);

    useEffect(() => initForm(), [initForm]);

    return {
        form,
        color,
        loading,
        infoClickup,
        changeColor,
        setLoading,
        getSpacesClickupForSection,
        getListsByClickupSpace
    }
}

export default useForm